import { z } from 'zod';
import { useTranslation } from 'react-i18next';
import { useBoundStore } from '@Store/useBoundStore';
import { usePostEddData } from '@Pages/happyFlowPages/eddQuestions/hooks/usePostEddData';
import { EDD_VERSION } from '@Pages/happyFlowPages/eddQuestions/consts';
import {
  getDefaultValueByQuestionId,
  saveEddQuestionToLocalStore,
} from '@Pages/happyFlowPages/eddQuestions/shared.utils';
import { useNavigationManager } from '@Router/useNavigationManager';
import { useFormHook } from '@Hooks/index';
import { RoutesMap } from '@Router/router.types';
import { EddEmbeddedFields } from '../fields.types';

export const useWhatDoYouSellLogic = () => {
  const { getEddEmbeddedQuestions } = useBoundStore((state) => state);
  const { mutateAsync: postEddData, isPending: isPostingEddData } = usePostEddData();
  const { navigateToNextPage } = useNavigationManager();
  const { t } = useTranslation('eddQuestions');

  const formMethods = useFormHook({
    schemaTitle: 'edd-embedded-what-do-you-sell',
    formSchema: z.object({
      [EddEmbeddedFields.EDD_EMBEDDED_WHAT_DO_YOU_SELL]: z
        .string()
        .min(30, 'Description must be at least 30 characters')
        .max(300, 'Description must be less than 300 characters'),
    }),
    formDefaultValues: {
      [EddEmbeddedFields.EDD_EMBEDDED_WHAT_DO_YOU_SELL]:
        getDefaultValueByQuestionId(EddEmbeddedFields.EDD_EMBEDDED_WHAT_DO_YOU_SELL) || '',
    },
  });

  const handleSubmit = async () => {
    /** Save to local store */
    saveEddQuestionToLocalStore({
      question: t('embedded.a.content'),
      questionId: EddEmbeddedFields.EDD_EMBEDDED_WHAT_DO_YOU_SELL,
      answer: JSON.stringify(
        formMethods.getValues(EddEmbeddedFields.EDD_EMBEDDED_WHAT_DO_YOU_SELL)
      ),
    });

    /** Save to Server */
    try {
      await postEddData({
        version: EDD_VERSION,
        results: getEddEmbeddedQuestions(),
      });
      navigateToNextPage(RoutesMap.EDD_EMBEDDED_WHAT_DO_YOU_SELL);
    } catch (error) {
      /** TODO: Handle error - Check with PM */
      console.error(error);
    }
  };

  return {
    formMethods,
    handleSubmit,
    isPostingEddData,
  };
};
